module.exports = __webpack_public_path__ + "img/zutto-pink-dragons.6d1d466.jpg";